import React, { FunctionComponent, useReducer } from "react";
import { reducer } from "./reducers";
import { AppContext, defaultState } from "./store";

export const LinesStateProvider: FunctionComponent = ({ children }) => {
  const [globalState, dispatch] = useReducer(reducer, defaultState);
  return (
    <AppContext.Provider
      value={{ globalState, dispatch }}
      children={children}
    />
  );
};
